import { getPriceScale } from '@/shared/helpers/markets';
import { Asset, Market, supportedLangs } from '@cex/shared-modules';
import Big from 'big.js';
import mapKeys from 'lodash/fp/mapKeys';
import snakeCase from 'lodash/fp/snakeCase';

export type FormatAssetOptions = {
  amount?: Big | string | number;
  asset: Asset;
  lang: string;
  withSymbol?: boolean;
  options?: { decimals?: number };
};

export type FormatPercentOptions = {
  amount?: number;
  decimals?: number;
  lang: string;
  showPlus?: boolean;
};

export type FormatNumberOptions = {
  number: number | Big | string;
  lang: string;
  decimals?: number;
};

export const keysToSnakeCase = mapKeys(snakeCase);
export const intlNumberFormat = (market: Market, lang: string, isCurrency?: boolean, digit = 0) => {
  const formatted = new Intl.NumberFormat(supportedLangs.codes[lang], {
    style: isCurrency ? 'currency' : '',
    currency: isCurrency ? market?.quote.basicCode : '',
    minimumFractionDigits: getPriceScale(market),
    maximumFractionDigits: getPriceScale(market)
  }).format(digit);

  const digitZero = `${formatted.replace(/0/g, '–')}`;

  return digit === 0 ? digitZero : formatted;
};
